<template>
    <div>{{ innerValue }}</div>
</template>

<script>
import { isArray, isPlainObject, getLabelByValue, isFunction } from '@lsfe/tools';

// 缓存 promise
const CachePromise = {};

export default {
    name: 'formatEnum',
    props: {
        value: {},
        scope: {},
        list: {
            type: [Array, Object, Function],
            required: true
        }
    },
    asyncComputed: {
        async innerValue() {
            const { list, value, scope } = this;
            const { property } = scope.column;
            let innerList = [];

            if (isFunction(list)) {
                if (!CachePromise[property]) {
                    CachePromise[property] = Promise.resolve(list());
                }
                const res = await CachePromise[property];
                return getLabelByValue(value, res);
            }
            if (isArray(list)) {
                innerList = [...list];
            }
            if (isPlainObject(list)) {
                return list[value] || '--';
            }
            return getLabelByValue(value, innerList);
        }
    }
};
</script>
